var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoupeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.25 90.375C96.1875 91.3125 96.1875 92.625 95.25 93.5625L93.375 95.4375C92.4375 96.375 91.125 96.375 90.1875 95.4375L66 71.25C65.625 70.875 65.4375 70.3125 65.4375 69.5625V67.6875C58.5 74.0625 49.125 78 39 78C17.4375 78 0 60.5625 0 39C0 17.625 17.4375 0 39 0C60.375 0 78 17.625 78 39C78 49.3125 74.0625 58.5 67.5 65.625H69.5625C70.125 65.625 70.6875 65.8125 71.0625 66.1875L95.25 90.375ZM39 72C57.1875 72 72 57.375 72 39C72 20.8125 57.1875 6 39 6C20.625 6 6 20.8125 6 39C6 57.375 20.625 72 39 72Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupeicon);
export default __webpack_public_path__ + "static/media/loupeicon.3d70fb7eeb7a73dba72fe352bcd6b70c.svg";
export { ForwardRef as ReactComponent };